export default defineNuxtPlugin(() => {
  const { gtag, initialize, disableAnalytics, enableAnalytics } = useGtag()

  let initialized = false

  function activateAnalytics() {
    if (!initialized) {
      initialize()
      initialized = true
    }
    else {
      enableAnalytics()
    }
  }

  function trackPageView() {
    const currentRoute = useRouter().currentRoute.value

    if (!gtag) {
      return
    }

    applyAnalyticsUserId(gtag)
    gtag('event', 'page_view', {
      ...useAdvisorCountryParams(),
      page_title: document.title,
      page_location: window.location.href,
      page_path: currentRoute.fullPath,
    })
  }

  useProjectTelemetryPageTracking({
    activate: activateAnalytics,
    deactivate: disableAnalytics,
    trackPageView,
  })
})
